// vue component for product FAQ
import ProductFAQ from '@/front/components/product/ProductFAQ'

function faq() {
  const faqTab = document.querySelector('[href="#tab-faq"]')
  Vue.prototype.$api = window.$api

  faqTab.addEventListener('click',() => {
    new Vue({
      el:'#vue-product-faq',
      render: h => h(ProductFAQ)
    })
  })
}

faq()
